<div class="signature-callback-container">
  <ng-container [ngSwitch]="viewState">
    
    <div *ngSwitchCase="ViewState.Loading" class="loading-state">
      <mat-spinner diameter="50"></mat-spinner>
      <p>{{ 'SignatureCallback.Loading' | translate }}</p>
    </div>

    <div *ngSwitchCase="ViewState.PinEntry" class="pin-entry-state">
      <mat-card class="pin-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon color="primary">lock</mat-icon>
            {{ 'SignaturePin.Title' | translate }}
          </mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <p class="info-text">{{ 'SignaturePin.Description' | translate }}</p>

          <div *ngIf="pinErrorMessage" class="error-banner">
            <mat-icon color="warn">error</mat-icon>
            <span>{{ pinErrorMessage }}</span>
          </div>

          <form [formGroup]="pinForm" (ngSubmit)="onSubmitPin()">
            <mat-form-field appearance="outline" class="pin-field">
              <mat-label>{{ 'SignaturePin.PinLabel' | translate }}</mat-label>
              <input matInput [type]="hidePin || isSubmitting ? 'password' : 'text'" formControlName="pin" maxlength="8" />
              <button mat-icon-button matSuffix (click)="hidePin = !hidePin" type="button" tabindex="-1">
                <mat-icon>{{ hidePin ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              <mat-error *ngIf="pin.invalid && pin.touched">{{ pinValidationErrorMessage }}</mat-error>
            </mat-form-field>

            <div class="actions">
              <button mat-button type="button" (click)="onCancel()" [disabled]="isSubmitting">
                {{ 'SignaturePin.Cancel' | translate }}
              </button>
              <button mat-raised-button color="primary" type="submit" [disabled]="pinForm.invalid || isSubmitting">
                {{ 'SignaturePin.Submit' | translate }}
              </button>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    </div>

    <div *ngSwitchCase="ViewState.Success" class="success-state">
      <mat-card class="result-card success-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon color="primary" class="result-icon">check_circle</mat-icon>
            {{ 'SignatureCallback.SuccessTitle' | translate }}
          </mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <p class="result-message">{{ successMessage }}</p>
        </mat-card-content>

        <mat-card-actions align="end">
          <button mat-raised-button color="primary" (click)="onNavigate()">
            {{ 'SignatureCallback.NavigateButton' | translate }}
          </button>
        </mat-card-actions>
      </mat-card>
    </div>

    <div *ngSwitchCase="ViewState.Error" class="error-state">
      <mat-card class="result-card error-card">
        <mat-card-header>
          <mat-card-title align="center">
            <mat-icon color="warn" class="result-icon">error</mat-icon>
            {{ 'SignatureCallback.ErrorTitle' | translate }}
          </mat-card-title>
        </mat-card-header>

        <mat-card-content align="center">
          <p class="result-message">{{ errorMessage }}</p>
        </mat-card-content>

        <mat-card-actions align="end">
          <button mat-raised-button color="primary" (click)="onNavigate()">
            {{ 'SignatureCallback.NavigateButton' | translate }}
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    
  </ng-container>
</div>
